<template>
  <div id="page-all-projects">
  <div id="active-page" :class="{'page-fade': !mountedPage}"></div>
    <modal-del-proj :projects="projectsToDelete" :showModalDel="modalDel" @close="modalDel = false"></modal-del-proj>
    <h1>{{$t('titles.allProjects')}}</h1>
    <v-container fluid>
      <v-layout row wrap px-6>
        <folder-parent-enfant 
          v-for="projects in listOfAllProjects" 
          :key="projects.parent.uuid"
          :projects="projects" 
          :deletable="true"
          @delete-project="showModal"
        />
      </v-layout>
    </v-container>
 </div>
</template>

<script>
import close from "../../components/icons/close.vue";
import folderParentEnfant from "@/components/folder-parent-enfant.vue";
import modalDelProj from "@/components/modals-form/modal-del-proj.vue";
export default {
  props: {
    source: String
  },
  components: {
    close,
    folderParentEnfant,
    modalDelProj
  },
  data() {
    return {
      elements: [],
      route_current: this.$route.path,
      modalDel: false,
      projectsToDelete: [],
      listOfAllProjects: [],
      mountedPage: false
    };
  },
  watch: {
    updatedProjects: {
      handler(projects) {
        this.organizeProjects(projects);
      },
      deep: true
    }
  },
  beforeMount() {
    if (this.listOfAllProjects.length === 0)
      this.organizeProjects(this.updatedProjects);
  },
  computed: {
    updatedProjects() {
      let projects = this.$store.getters['project/getProjects'];
      return projects;
    }
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch("project/getProjects")
    },
    showModal(projectsToDelete) {
      this.projectsToDelete = projectsToDelete;
      this.modalDel = true;
    },
    organizeProjects(projects) {
      if (projects == 'null') return [];
      projects = JSON.parse(JSON.stringify(projects));
      this.listOfAllProjects = this.projObjParentsChilds(projects);
    }
  },
  mounted() {
    setTimeout(() => this.mountedPage = true, 100);
  }
};
</script>
<style>

</style>

